/* eslint-disable @typescript-eslint/no-explicit-any */

export const PROMISE_SUPERSEDED_ERROR_MESSAGE = 'promise superseded by a new invocation';

/**
 * This function wraps any function that returns a promise, and will reject promises returned by the previous
 * invocation if it is still pending when the function is invoked again.
 * @param func Any function that returns a promise
 */
export const rejectSupersededInvocation = (func: (...args: any[]) => Promise<any>) => {
  let mostRecentPromise: Promise<any>;

  function wrapper(...args: any[]) {
    const promise = func(...args).then((originalPromiseValue) => {
      if (promise === mostRecentPromise) {
        return originalPromiseValue;
      }

      return Promise.reject(PROMISE_SUPERSEDED_ERROR_MESSAGE);
    });

    mostRecentPromise = promise;

    return promise;
  }
  return wrapper;
};
